import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';

const UserLayot = (props) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const user = localStorage.getItem('name');
  const role = localStorage.getItem('role');

  return (
    <div>
      <Header
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        Heading="Faculty"
        Btn="42"
        P1="Dashboard"
        R1="/UserHome"
        i1="bi bi-grid"
        Ac1={props.ac1}
        P2="Answersheet"
        R2="/AnswerSheet"
        i2="bi bi-journal-bookmark-fill"
        Ac2={props.ac2}
        P3="Reassessments"
        R3="/ReassExams"
        i3="bi bi-bootstrap-reboot"
        Ac3={props.ac3}
        P4="Profile"
        R4="/Profile"
        i4="bi bi-person-circle"
        Ac4={props.ac4}
        P6=""
        R6=""
        i6=""
        op="Profile"
        opr="/Profile"
        opi="bi bi-person-circle"
        op1="History"
        opr1="/FacityHistory"
        opi1="bi bi-clock-history"
        user={user}
        role={role}
        h1="/UserHome"
      />
      <main className={` main ${sidebarOpen ? 'open' : 'close'}`}>
        <div className="main-herder">{props.children}</div>
        <Footer />
      </main>
    </div>
  );
};

export default UserLayot;
